import { ApiResponse, ApiResponseObject } from '@interfaces/api-response/1.0';

export interface Association extends ApiResponseObject, AssociationListItem {
  tenantId: string;
  catalogEntryId: string;
  rawPosValue: string;
  dataGroupId: string;
  associationLookupType: AssociationLookupType;
  associationType: AssociationType;
  posMapping?: {
    isNew: boolean;
    scope: 'PRIMARY_STORE';
  };
  associatedCatalogEntryIds?: string[];
  associatedCatalogEntryId?: string;
  contextCatalogEntryId?: string;
}

export enum AssociationLookupType {
  INSTRUCTION = 'INSTRUCTION',
  MODIFIER = 'MODIFIER',
  MODIFIER_GROUP = 'MODIFIER_GROUP',
  PRODUCT = 'PRODUCT',
  PRODUCT_GROUP = 'PRODUCT_GROUP',
  COMPOSITE = 'COMPOSITE',
}

export interface AssociationResponse extends ApiResponse {
  _embedded: {
    associations: Association[];
  };
}

export enum AssociationType {
  POS_MODIFIER_CODE_VALUE_TO_TCE_INSTRUCTION = 'POS_MODIFIER_CODE_VALUE_TO_TCE_INSTRUCTION',
  MODIFIER_CODE_AND_MODIFIER_TO_TCE_MODIFIER = 'MODIFIER_CODE_AND_MODIFIER_TO_TCE_MODIFIER',
  MODIFIER_SKU_TO_TCE_INSTRUCTION = 'MODIFIER_SKU_TO_TCE_INSTRUCTION',
  SINGLE_PRODUCT_SKU_TO_TCE_PRODUCT = 'SINGLE_PRODUCT_SKU_TO_TCE_PRODUCT',
  MODIFIER_SKU_TO_TCE_PRODUCT = 'MODIFIER_SKU_TO_TCE_PRODUCT',
  PRODUCT_TO_TCE_COMBO = 'PRODUCT_TO_TCE_COMBO',
  PRODUCT_TO_TCE_COMBO_HERO_PRODUCT = 'PRODUCT_TO_TCE_COMBO_HERO_PRODUCT',
  PRODUCT_TO_TCE_BUNDLE = 'PRODUCT_TO_TCE_BUNDLE',
  COMBO_TO_TCE_COMPOSITE = 'COMBO_TO_TCE_COMPOSITE',
}

interface AssociationListItem {
  isSaved?: boolean;
  description?: string;
  rawPosLookup?: string;
  isDeleting?: boolean;
}
